import translation from "./translation.json";
import stopPage from "./stopPage.json";
import authPage from "./authPage.json";
import addDropoffPage from "./addDropoffPage.json";
import types from "./types.json";
import waypointPage from "./waypointPage.json";
import topBar from "./topBar.json";
import notifications from "./notifications.json";
import undispatchedCargos from "./undispatchedCargos.json";
import gps from "./gps.json";
import routeWithStops from "./route-with-stops.json";
import components from "./components.json";

const lang = {
  translation,
  stopPage,
  authPage,
  addDropoffPage,
  types,
  waypointPage,
  topBar,
  notifications,
  undispatchedCargos,
  gps,
  routeWithStops,
  components,
};

export default lang;
